"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var pipe_ts_1 = require("pipe-ts");

var urlHelpers = require("url");

var maybe_1 = require("./helpers/maybe");

var other_1 = require("./helpers/other");

var getPathnameFromParts = function getPathnameFromParts(parts) {
  return "/" + parts.join('/');
};

var getPartsFromPathname = function getPartsFromPathname(pathname) {
  return pathname.split('/').filter(other_1.isNonEmptyString);
};

var parseUrlWithQueryString = function parseUrlWithQueryString(url) {
  return urlHelpers.parse(url, // Parse the query string
  true);
};

var convertNodeUrl = function convertNodeUrl(_a) {
  var auth = _a.auth,
      hash = _a.hash,
      hostname = _a.hostname,
      pathname = _a.pathname,
      port = _a.port,
      protocol = _a.protocol,
      query = _a.query,
      slashes = _a.slashes;
  return {
    auth: auth,
    hash: hash,
    hostname: hostname,
    pathname: pathname,
    port: port,
    protocol: protocol,
    query: query,
    slashes: slashes
  };
};

exports.mapParsedUrl = function (fn) {
  return function (_a) {
    var parsedUrl = _a.parsedUrl;
    return fn({
      parsedUrl: parsedUrl
    });
  };
};

exports.mapUrl = function (fn) {
  return pipe_ts_1.pipe(function (_a) {
    var url = _a.url;
    return parseUrlWithQueryString(url);
  }, convertNodeUrl, function (parsedUrl) {
    return fn({
      parsedUrl: parsedUrl
    });
  }, urlHelpers.format);
};

exports.replaceQueryInParsedUrl = function (_a) {
  var newQuery = _a.newQuery;
  return function (_a) {
    var parsedUrl = _a.parsedUrl;
    return __assign({}, parsedUrl, {
      query: newQuery instanceof Function ? newQuery(parsedUrl.query) : newQuery
    });
  };
};

exports.replaceQueryInUrl = other_1.flipCurried(pipe_ts_1.pipe(exports.replaceQueryInParsedUrl, exports.mapUrl));

exports.addQueryToParsedUrl = function (_a) {
  var queryToAppend = _a.queryToAppend;
  return exports.replaceQueryInParsedUrl({
    newQuery: function newQuery(existingQuery) {
      return __assign({}, existingQuery, queryToAppend);
    }
  });
};

exports.addQueryToUrl = other_1.flipCurried(pipe_ts_1.pipe(exports.addQueryToParsedUrl, exports.mapUrl));
var parsePath = pipe_ts_1.pipe(function (path) {
  return urlHelpers.parse(path, true);
}, function (_a) {
  var query = _a.query,
      pathname = _a.pathname;
  return {
    query: query,
    pathname: pathname
  };
});

var getParsedPathFromString = function getParsedPathFromString(maybePath) {
  return pipe_ts_1.pipeWith(maybePath, function (maybe) {
    return maybe_1.mapMaybe(maybe, parsePath);
  }, function (maybe) {
    return maybe_1.getOrElseMaybe(maybe, function () {
      return {
        query: {},
        pathname: null
      };
    });
  });
};

exports.replacePathInParsedUrl = function (_a) {
  var newPath = _a.newPath;
  return function (_a) {
    var parsedUrl = _a.parsedUrl;
    return pipe_ts_1.pipeWith(newPath instanceof Function ? newPath(parsedUrl.pathname) : newPath, getParsedPathFromString, function (newPathParsed) {
      return __assign({}, parsedUrl, newPathParsed);
    });
  };
};

exports.replacePathInUrl = other_1.flipCurried(pipe_ts_1.pipe(exports.replacePathInParsedUrl, exports.mapUrl));

exports.replacePathnameInParsedUrl = function (_a) {
  var newPathname = _a.newPathname;
  return function (_a) {
    var parsedUrl = _a.parsedUrl;
    return __assign({}, parsedUrl, {
      pathname: newPathname instanceof Function ? newPathname(parsedUrl.pathname) : newPathname
    });
  };
};

exports.replacePathnameInUrl = other_1.flipCurried(pipe_ts_1.pipe(exports.replacePathnameInParsedUrl, exports.mapUrl));

exports.appendPathnameToParsedUrl = function (_a) {
  var pathnameToAppend = _a.pathnameToAppend;
  return exports.replacePathnameInParsedUrl({
    newPathname: function newPathname(prevPathname) {
      var pathnameParts = pipe_ts_1.pipeWith(maybe_1.mapMaybe(prevPathname, getPartsFromPathname), function (maybe) {
        return maybe_1.getOrElseMaybe(maybe, function () {
          return [];
        });
      });
      var pathnamePartsToAppend = getPartsFromPathname(pathnameToAppend);
      var newPathnameParts = pathnameParts.concat(pathnamePartsToAppend);
      var newPathname = getPathnameFromParts(newPathnameParts);
      return newPathname;
    }
  });
};

exports.appendPathnameToUrl = other_1.flipCurried(pipe_ts_1.pipe(exports.appendPathnameToParsedUrl, exports.mapUrl));

exports.replaceHashInParsedUrl = function (_a) {
  var newHash = _a.newHash;
  return function (_a) {
    var parsedUrl = _a.parsedUrl;
    return __assign({}, parsedUrl, {
      hash: newHash instanceof Function ? newHash(parsedUrl.hash) : newHash
    });
  };
};

exports.replaceHashInUrl = other_1.flipCurried(pipe_ts_1.pipe(exports.replaceHashInParsedUrl, exports.mapUrl));